import { useTextes } from '@common/config';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const Z_LAST_NAME = Z_TEXT(t['ADM_MES3'])
  .min(2, { error: 'Le Nom doit être composé d\'au moins 2 caractères.' })
  .regex(/^\p{L}[\p{L}\p{M}\-'’"\s]+$/u, { error: 'Le Nom ne doit pas contenir de chiffres.' })
  .max(200);

export const LAST_NAME_PLACEHOLDER = 'Durand';